<div mat-dialog-title class="dialog-header">
    <div>
        <h4 class="modal-title">Activiteit</h4>
    </div>
    <button aria-label="Close" class="close-button" mat-dialog-close="" tabindex="-1">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
@if (form) {
    <div mat-dialog-content [formGroup]="form" class="modal-body">
        <mat-form-field class="w-100">
            <mat-placeholder>Naam</mat-placeholder>
            <input [formControl]="fc.name" matInput type="text" />
            <mat-error [control]="fc.name"></mat-error>
        </mat-form-field>
        @if (assignees) {
            <mat-form-field class="w-100">
                <mat-placeholder>Verantwoordelijke</mat-placeholder>
                <mat-select (selectionChange)="assigneeChange($event)" [value]="assignee">
                    @for (assignee of assignees; track assignee) {
                        <mat-option [value]="assignee">
                            {{ assignee.name }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }
        <mat-form-field (click)="deadline.open()" class="w-100">
            <mat-label>Deadline</mat-label>
            <input [formControl]="fc.deadline" [matDatepicker]="deadline" matInput />
            <mat-datepicker-toggle [for]="deadline" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #deadline></mat-datepicker>
            <mat-error [control]="fc.deadline"></mat-error>
        </mat-form-field>
    </div>
}
<div mat-dialog-actions class="modal-footer">
    @if (phaseActivity.id) {
        <button (click)="delete()" color="warn" mat-button>Verwijderen</button>
    }
    <div class="flex-fill"></div>
    <button color="primary" mat-button mat-dialog-close="" type="button">Sluiten</button>
    <button (click)="save()" [disabled]="form.invalid || saving" color="primary" mat-raised-button type="button">
        Opslaan
        @if (saving) {
            <i class="fas fa-circle-notch fa-spin"></i>
        }
    </button>
</div>
